function Rating({ ratingValue }) {
    return <p className="product_rating">Average Rating: {ratingValue}</p>;
}

export default Rating;